import React, { useState, useEffect } from "react";
import Login from "./pages/Login";
import Game from "./pages/Game";
import Score from "./pages/Score";
import AuthSvc from "./services/AuthSvc";
import("./styles/main.less");

const App = () => {
  const [view, setView] = useState(null);
  const [score, setScore] = useState(0);
  const [questionsLength, setQuestionsLength] = useState(0);
  // "start" shows the Começar screen; "retry" jumps straight into a new game.
  const [gameMode, setGameMode] = useState("start");
  // Increments on every (re)start so <Game> always remounts with fresh state.
  const [gameRound, setGameRound] = useState(0);
  const [loginVisible, setLoginVisible] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      const user = await AuthSvc.isAuthenticated();
      const allowResume = localStorage.getItem("allowResume") === "true";

      if (user || allowResume) {
        setView("game");
      } else {
        localStorage.removeItem("allowResume");
        setLoginVisible(true);
      }
    };
    checkAuth();
  }, []);

  const handleLogin = async (credentials) => {
    try {
      const { success, token } = await AuthSvc.login(credentials);
      if (success) {
        localStorage.setItem("authToken", token);
        localStorage.setItem("allowResume", "true");
        setLoginVisible(false);
        setGameMode("start");
        setView("game");
      }
    } catch (err) {
      alert("Login failed");
    }
  };

  const handleGameEnd = (finalScore, totalQuestions) => {
    setScore(finalScore);
    setQuestionsLength(totalQuestions);
    setView("score");
  };

  const handleRetry = (action) => {
    if (action === "retry") {
      localStorage.setItem("allowResume", "true");
      setGameMode("retry");
    } else if (action === "exit") {
      localStorage.removeItem("allowResume");
      localStorage.removeItem("playerId");
      setGameMode("start");
    }
    // Bump the round so Game remounts cleanly on every attempt.
    setGameRound((round) => round + 1);
    setView("game");
  };

  return (
    <div className="app">
      {loginVisible && <Login onLogin={handleLogin} />}
      {view === "game" && (
        <Game key={gameRound} onGameEnd={handleGameEnd} restart={gameMode} />
      )}
      {view === "score" && (
        <Score score={score} total={questionsLength} onRetry={handleRetry} />
      )}
    </div>
  );
};

export default App;